<template>
    <div>
        <app-select id="make_id"
                    v-model="form.make_id"
                    :options="makes.map(c => c.id)"
                    name="make_id"
                    rules="required"
                    searchable
                    not-empty
                    closeOnSelect
                    :custom-label="id => makes.some(c => c.id === id) ? makes.find(c => c.id === id).name : null">
            <template #label>
                {{ $t('Make') }}*
            </template>
        </app-select>
        <app-input id="name" v-model="form.name" name="name" rules="required">
            <template #label>
                {{ $t('Name') }}*
            </template>
        </app-input>
    </div>
</template>

<script>
import VehicleService from '@services/vehicle.service';

export default {
    name: 'MakeForm',
    props: {
        form: Object
    },
    data() {
        return {
            makes: [],
        };
    },
    methods: {
        getMakes(){
            VehicleService.makes().then(res => this.makes = res);
        }
    },
    created() {
        this.getMakes();
    }
};
</script>
